import React, { useMemo } from "react";
import { ThemeProvider } from "styled-components";
import { getPartnerConfig } from "utils/partner";
import { getTheme } from "utils/theme";

const ThemeContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const partner = getPartnerConfig();
  const theme = useMemo(() => getTheme(partner?.slug), [partner]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default ThemeContainer;
